import React, {useState, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Accordion, AccordionDetails, AccordionSummary, Button, Typography, AccordionActions, Grid} from '@material-ui/core';
import {RecommendedActionsModal} from './Modals/';
import {StyledTextField} from 'components/';
import {ExpandMore} from '@material-ui/icons';

const RecommendedActionsPanel = ({selectedRootCause}) => {
  const [modalOpen, setModalOpen] = useState(false);

  return <Accordion defaultExpanded={false}>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Typography>Recommended Actions</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Grid container spacing={2}>
        {selectedRootCause.RecommendedActions.length ? selectedRootCause.RecommendedActions.map((action, index) => (
          <Fragment key={index}>
            <Grid item xs={6} >
              <StyledTextField value={action.Action} label='Action' />
            </Grid>
            <Grid item xs={6} key={index}>
              <StyledTextField value={action.Comment} label='Comment' />
            </Grid>
          </Fragment>
        )) : null}
        {!selectedRootCause.RecommendedActions.length ? <Grid item xs={12}><Typography>A Recommended Action have not been entered yet.</Typography></Grid> : null}
      </Grid>
    </AccordionDetails>
    <AccordionActions>
      {selectedRootCause.Status !== 'Completed' ? <Button variant='outlined' onClick={() => setModalOpen(true)} color='primary'>Update Recommended Actions</Button> : null}
    </AccordionActions>
    {modalOpen && <RecommendedActionsModal selectedRootCause={selectedRootCause} close={() => setModalOpen(false)} />}
  </Accordion>;
};

RecommendedActionsPanel.propTypes = {
  selectedRootCause: PropTypes.object.isRequired,
};

export default RecommendedActionsPanel;
